import { ClassAttributes, ReactNode } from 'react';
import { match as Match } from 'react-router';
import { lifecycle } from 'recompose';

type Props<UrlParams = Record<string, string>> = ClassAttributes<HTMLElement> & {
  match?: Match<UrlParams>;
  isRouteChanged?: (match: Match<UrlParams>, previousMatch: Match<UrlParams>) => boolean;
  onMount?: () => void;
  onUnmount?: () => void;
  children: ReactNode;
};

const RouteLifecycleWrapper = lifecycle<Props, Record<string, unknown>>({
  componentDidMount: function () {
    if (this.props.onMount) this.props.onMount();
  },
  componentWillUnmount: function () {
    if (this.props.onUnmount) this.props.onUnmount();
  },
  componentDidUpdate: function (prevProps) {
    if (
      this.props.isRouteChanged &&
      this.props.isRouteChanged(this.props.match || ({} as any), prevProps.match || ({} as any))
    ) {
      if (this.props.onMount) this.props.onMount();
      if (this.props.onUnmount) this.props.onUnmount();
    }
  },
})(({ children }: Props) => children as any);

export default RouteLifecycleWrapper;
